<template>
  <CButton class="btn-secondary" v-on="$listeners" :text="text">
    <i v-if="iconClass" :class="iconClass"></i>
  </CButton>
</template>

<script>
import CButton from "../partials/CButton";

export default {
  components: {
    CButton,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    iconClass: {
      type: String,
      default: null,
    },
  },
};
</script>
